import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Chip, TableCell, TableRow, Typography } from '@mui/material';
import SvgIconStyle from 'components/SvgIconStyle';
// import { renderRowCreatedAt } from 'utils/renderTableCell';

export function TagsRow({ row, index }) {
  const navigate = useNavigate();
  const { name, image, tagObjects } = row;
  return (
    <>
      <TableRow key={index} hover>
        <TableCell align="left">
          <Typography>{index + 1}</Typography>
        </TableCell>
        <TableCell
          align="left"
          sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}
        >
          <img src={image} alt={name} style={{ width: 48, height: 48 }} />
          <Typography>{name}</Typography>
        </TableCell>
        <TableCell align="left">
          {tagObjects.length > 0 ? (
            tagObjects.map((x, i) => <Chip key={i} label={x.name} />)
          ) : (
            <Typography variant="body2" color="GrayText">
              بدون تگ
            </Typography>
          )}
        </TableCell>
        <TableCell>
          <div onClick={() => navigate('/dashboard/recommendation/relation/edit', { state: row })} aria-hidden>
            <SvgIconStyle src="/icons/send_icon.svg" sx={{ width: 20, height: 20, cursor: 'pointer' }} />
          </div>
        </TableCell>
      </TableRow>
    </>
  );
}
